module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter_head"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "ch13"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _vm._v("CHAPTER 01")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter_title"
  }, [_vm._v("On a ’Role")]), _vm._v(" "), _c('p', {
    staticClass: "chapter_head_note"
  }, [_vm._v("This much I know: Some of you like taking an orderly approach to casserole cooking, while many of you simply want to dump and stir. Some of you prefer making everything from scratch, while many of you covet your can openers. No matter your style, I’m all for it. Just as long as it tastes good. And good it will be if you understand a few things before setting out to make a fashionable and flavorful Southern casserole.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2_text"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("GOOD TO KNOW, THEN GOOD TO GO")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("GOOD TIMING /")])]), _vm._v(" Based on my Dallas kitchen’s simple gas oven, whatever cooking time your sleek new convection appliance or old clunker needs to get the job done may not align perfectly, but the cooking time will indeed be very close. Just keep an eye on things. Check the dish ten minutes before its suggested completion time to gauge its ETA.")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("GOOD PLACEMENT /")])]), _vm._v(" Recipe times, and success rates, can vary greatly if you don’t use the proper dish. If it’s too shallow, your casserole will cook too quickly and be dry; if it’s too deep, it won’t cook evenly (meaning it’ll be gooey in the middle). Follow the instructions first, then feel free to improvise once you understand the recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("GOOD TASTE /")])]), _vm._v(" Adjust each casserole’s seasonings to suit yourself. If you’re not a fan of garlic, just cut back on what I suggest. (Or, if you’re really not a fan, don’t include it at all.) Some I know think green onions are spicy, and that’s as far as they’ll go to add snap to their dish. Others say bring on not one jalapeño but two serrano chiles. You just do what the common-sense fairy tells you in order to make "), _c('em', [_vm._v("your")]), _vm._v(" taste buds happy.")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("GOOD PLANNING /")])]), _vm._v(" Most of these recipes can be made the night before; in fact, having a dish’s flavors come together for at least four and up to eight hours in the refrigerator often improves it. And if a cheese or a crunchy topping is part of a dish, I’ll let you know when those ingredients should be added (usually just before baking, so the food won’t get mealy).")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("5")]), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("GOOD EATING /")])]), _vm._v(" Leftovers can be kept tightly covered in the refrigerator for several days without having their flavor compromised, though seafood casseroles should be eaten within one or two days, if you catch my, well, its (aroma) drift.")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("6")]), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("GOOD FREEZING /")])]), _vm._v(" Most of these recipes can be frozen "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_chapter01g#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(see “Just Chill,” page 41, for more on that)")]), _vm._v(". If for some reason it’s not advisable (i.e., if the sauce might separate and become watery), I’ll be sure to note that. Also, leftovers that have been refrigerated a couple of days will not freeze well; their unraveling flavors and texture will disappoint once put to the deep-freeze test. I realize, however, that some of you won’t care a lick about what I just said and will go ahead and do it anyway, swearing that it’s just as good as the day you cooked it. I’m not here to judge—only offer guidelines. Oh, and some good recipes. But first things first.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3_text"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "lev1"
    }
  }), _vm._v("GET IT TOGETHER: PANTRY STAPLES")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_vm._v("The late and very great Southern cooking doyenne Edna Lewis once told me that always having a ham in the refrigerator was akin to keeping a little black dress on standby in your closet: With either, you’d be ready for anything. So, too, will your kitchen if you keep many of these core casserole ingredients on hand.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2_text"
  }, [_vm._v("IN THE PANTRY")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Baking ingredients:")])]), _vm._v(" All-purpose flour, cornmeal, baking mix (i.e., Bisquick), cornbread mix, baking soda, baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Bread crumbs:")])]), _vm._v(" Soft seasoned/unseasoned and panko")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Broths:")])]), _vm._v(" Chicken, beef, and vegetable")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Canned tuna")])]), _vm._v(" (chunk light and solid white) "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("and chicken")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Cheese:")])]), _vm._v(" Processed loaf (i.e., Velveeta)")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Chiles:")])]), _vm._v(" Diced green, sliced jalapeño")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Grits:")])]), _vm._v(" Quick-cooking (not instant) and stone-ground")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Nuts:")])]), _vm._v(" Pecans, sliced/slivered almonds")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Oils:")])]), _vm._v(" Olive, vegetable, peanut")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Olives:")])]), _vm._v(" Pimiento-stuffed green, black, olive mix")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Pasta:")])]), _vm._v(" Dried spaghetti, penne, elbow, fettuccine, others")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Pasta sauces:")])]), _vm._v(" Commercially made tomato, Alfredo, pesto")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Rice:")])]), _vm._v(" Long-, short-, wild-grains; quick-cooking couscous")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Seasonings:")])]), _vm._v(" Ground sea or kosher salt, peppercorns for grinding, Italian, Cajun (low sodium), seafood, chili powder, cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Soups:")])]), _vm._v(" Canned cream of mushroom, celery, and chicken")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Stuffing mix")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Sweeteners:")])]), _vm._v(" granulated and brown sugars, light sweeteners (Splenda and agave nectar are my faves)")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Tomatoes:")])]), _vm._v(" Whole, diced (flavored/plain), sauce, paste, stewed with peppers")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Vegetables:")])]), _vm._v(" Canned corn, green beans, vegetable mix; black, white (cannellini, great Northern), and pinto; black-eyed peas")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Vinegars:")])]), _vm._v(" Pepper, balsamic, red wine")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Wine:")])]), _vm._v(" Red and white")]), _vm._v(" "), _c('h2', {
    staticClass: "h2_text"
  }, [_vm._v("IN THE ’FRIDGE")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Condiments:")])]), _vm._v(" Mayonnaise, ketchup, Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Cheese:")])]), _vm._v(" Cheddar, Mexican/Italian blends, freshly grated Parmesan")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Citrus:")])]), _vm._v(" Lemons, limes "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_chapter01#page_16"
    }
  }, [_vm._v("(see Artificial Intelligence, page 16)")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Dairy:")])]), _vm._v(" Butter, margarine, milk, half-and-half, cream, sour cream, cream cheese")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Dough:")])]), _vm._v(" Canned biscuits, pie crusts, puff pastry")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Eggs")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Garlic:")])]), _vm._v(" Minced, pureed")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Meat:")])]), _vm._v(" Ham, bacon")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Onions:")])]), _vm._v(" Green, red, sweet, white")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Potatoes:")])]), _vm._v(" Russet, red (new)")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Sauces:")])]), _vm._v(" Hot, soy, Worcestershire")]), _vm._v(" "), _c('h2', {
    staticClass: "h2_text"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("IN THE FREEZER")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Casseroles, of course!")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Dough:")])]), _vm._v(" Garlic bread, dinner rolls, biscuits, pie crusts")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Fruit")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Meat/seafood:")])]), _vm._v(" Chicken breasts, shrimp")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Onion/celery/bell pepper mix")])]), _vm._v(" (a.k.a. “the holy trinity,” "), _c('span', {
    attrs: {
      "href": "#/xhtml/60_chapter04f#page_145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("see Lil’ Dish, page 145")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Vegetables:")])]), _vm._v(" Corn, green peas, lima beans, spinach")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar_1_hd"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("ARTIFICIAL INTELLIGENCE: LEMONS AND LIMES")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar_2_txt"
  }, [_vm._v("Bottled lemon and lime juices? Just say no to their shapely charms. Their strongly sour and artificial flavor doesn’t even come close to the soft tart-sweet goodness of fresh citrus. You can buy the bottled similar-to-fresh juice (usually organic), and keep it refrigerated for a time. Or, of course, you can squeeze your own and keep it chilled or frozen. I often use specific ice trays to harbor one or two tablespoons of lemon and lime juice, then pop out what I need for a fresh fix. It thaws in no time.")])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar_1_hd"
  }, [_vm._v("LIL’ DISH")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar_1_hd"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("WHY GO ORGANIC?")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar_2_txt"
  }, [_vm._v("With more companies taking the organic high road, the cost of better-for-us fare is coming down while our awareness of its benefits is rising. (Though we Southerners have understood the beauty of harvesting fresh food from lush, healthy gardens for centuries.) For cost-cutting and/or mass-production reasons, many of the foods we eat have us ingesting traces of toxic and/or synthetic pesticides and fertilizers—insecticides, fungicides and herbicides, growth hormones, antibiotics, and genetic modifiers.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar_2_txt"
  }, [_vm._v("   Organic foods, however, are minimally processed without all of the above “enhancements”—or artificial ingredients, preservatives, or irradiation. Here are five good reasons to embrace organic foods:")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  }), _vm._v(" It’s better for us (see above).")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  }), _vm._v(" It’s better for our animals and agriculture (see above).")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  }), _vm._v(" It’s better for the environment (by decreasing pollution levels from, say, synthetic materials that make their way into our water supply).")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  }), _vm._v(" It’s better for our local farmers, who in some cases are struggling to keep an age-old family business—and revered Southern foodway—alive.")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  }), _vm._v(" It tastes better: It’s fresher, more flavorful, and nutrient-rich.")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar_2_txt"
  }, [_vm._v("If I had to suggest only one organic food for you to splurge on, I’d say go with organic dairy products—that is, unless savoring products from dairy cows treated with chemicals and milk that might be harboring antibiotics and bovine growth hormones, is just too darn yummy for you to resist. I’m just sayin’.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3_text"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "lev2"
    }
  }), _vm._v("THE DISH ON DISHES")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('strong', [_c('span', {
    staticClass: "font3"
  }, [_vm._v("SPACE HEATERS /")])]), _vm._v(" When it comes to the best baking dishes, glass, ceramic, cast-iron/enameled, and earthenware vessels are ideal for cooking casseroles, since they retain their heat long after you pull them from the oven. Yet with that in mind, they also heat slower than their metallic counterparts, so you might have to increase your cooking time by 20 to 30 percent. Although metal baking pans are good for creating a light crust, dark ones can dry out your casserole, and aluminum and cast-iron pans sometimes react with acidic foods like tomatoes, making them taste, well, tinnish, so save your cast-iron and enamelware pans for creamy, non-acidic recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('strong', [_c('span', {
    staticClass: "font3"
  }, [_vm._v("BY THE NUMBERS /")])]), _vm._v(" If you don’t have a specific casserole dish a recipe calls for, you often can use another pan if you know its equivalent volume. Dish dimensions make a difference in baking times—and affect whether or not to cover them (to preserve moistness in, say, a shallow dish). If you’re unsure of your pan size (vintage ones are often unmarked), lay a ruler across the top and measure from inner edge to inner edge. Measure the depth from bottom to top. To determine volume, use a measuring cup to fill the pan with water. (Then, when you know what quart-size it is, write its measurements on the pan’s bottom with an indelible marker for future reference).")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_vm._v("IF THE RECIPE CALLS FOR A . . .")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_vm._v("CONSIDER A . . .")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("1-quart dish (4 cups)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("6-by-2-inch round pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-by-1.5-inch round pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-by-1.5-inch pie pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4 (8-ounce) ramekins")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("1.5-quart dish (6 cups)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("8-by-2-inch round pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("10-by-1.5-inch pie pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-by-8-by-1.5-inch square pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("11-by-7-by-2-inch rectangular pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4 (12-ounce) or 6 (8-ounce) ramekins")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("2-quart dish (8 cups)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("9-by-2-inch round pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("9-by-2-inch pie pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-by-8-by-2-inch square pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("9-by-9-by-1.5-inch square pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8 (8-ounce) or 4 (16-ounce) ramekins")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("2.5-quart dish (10 cups)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("9-by-9-by-2-inch square pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8 (10-ounce) or 6 (14-ounce) ramekins")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("3-quart dish (12 cups)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("9-by-3-inch round pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("10-by-10-by-2-inch square pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("13-by-9-by-2-inch rectangular pan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2 (8-by-8-by-2-inch) pans")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8 (12-ounce) or 6 (16-ounce) ramekins")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c1451d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_chapter01.vue
// module id = 81
// module chunks = 0